import {IPhoneFieldValue} from "./PhoneField";

export function getPhoneNumberAsString(phoneNumber: IPhoneFieldValue) {
    return `${phoneNumber.code} ${phoneNumber.number}`;
}

export function getPhoneNumberAsObject(phoneNumber: string) {
    const arr = phoneNumber.split(" ");
    const code = parseInt(arr[0], 10);
    const num = arr[1];

    const fieldValue: IPhoneFieldValue = {
        code: isFinite(code) ? code : 48,
        number: !!num ? num : ""
    };

    return fieldValue;
}
import {IPhoneFieldValue} from "./PhoneField";

export function getPhoneNumberAsString(phoneNumber: IPhoneFieldValue) {
    return `${phoneNumber.code} ${phoneNumber.number}`;
}

export function getPhoneNumberAsObject(phoneNumber: string) {
    const arr = phoneNumber.split(" ");
    const code = parseInt(arr[0], 10);
    const num = arr[1];

    const fieldValue: IPhoneFieldValue = {
        code: isFinite(code) ? code : 48,
        number: !!num ? num : ""
    };

    return fieldValue;
}
